const request = {}

request.createRequest = function (params) {
  return {
    token: params.token,
    password: params.password,
    password_confirmation: params.password_confirmation
  }
}
export default { request }
